import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard-wide, movie, film" maskId="round-filled-radius-0-stroke-1.5-IconClapboardWide"><path d="M22 19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V10.5H22V19.25Z" fill="currentColor"/><path d="M6.75098 9H2V4.75C2 4.33579 2.33579 4 2.75 4H8.41797L6.75098 9Z" fill="currentColor"/><path d="M14 9H8.33301L10 4H15.667L14 9Z" fill="currentColor"/><path d="M22 9H15.582L17.249 4H21.25C21.6642 4 22 4.33579 22 4.75V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
